var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "sidebar-menu-container",
      attrs: { id: "distance-sidebar-menu" }
    },
    [
      _c("div", { staticClass: "sidebar-main-label" }, [
        _vm._v("Установите длину")
      ]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "sidebar-step-two-img-container" }, [
        _c("img", {
          staticClass: "sidebar-step-two-img",
          attrs: {
            src: _vm.urlForStatic(
              "/img/projectPreviewsDemo/perspective_tip_1.svg"
            )
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "sidebar-text-area" }, [
        _vm._v(
          "На этом шаге Вы также можете корректировать измерительную линию, перетаскиванием ее точек."
        )
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sidebar-text-area" }, [
      _vm._v("Теперь "),
      _c("span", { staticClass: "red-text bold-text" }, [
        _vm._v("задайте расстояние")
      ]),
      _vm._v(", соответствующее длине построенного отрезка\n        "),
      _c("span", { staticClass: "red-text bold-text" }, [
        _vm._v("на реальном участке")
      ]),
      _vm._v(
        ". Расстояние задаётся в поле ввода, расположенном на нижней панели."
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }